<div class="title">
    <div (click)="getUserNotif()" style="position: relative;">
        <img src="assets/img/Combined Shape.svg" alt="">
        <img class="notification" src="assets/img/Oval.svg" alt="" *ngIf="hasUnread">
    </div>
    <h1 class="header1">{{title}}</h1>
    <a [routerLink]="['/setting']" style="position: relative;">
      <img src="assets/img/Group.svg"  alt="">
      <img class="notification" src="assets/img/Oval.svg" alt="" *ngIf="showMsgBadge">
    </a>

</div>
<div class="modal fade" #notifModal tabindex="-1" role="dialog" id="notifModal" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" >
    <div class="modal-content">
      <div class="modal-body">
        <div class="notif">
          <div class="d-flex justify-content-sm-between top-section">
            <span class="notif_title">اعلانات</span>
            <button *ngIf="notifList !== null && notifList?.length > 0" class="btn redBtn btn-auto" (click)="openConfirmModal('all')">
              <img src="assets/img/white-trash.svg" alt="">
              حذف همه</button>
          </div>

          <div *ngIf="notifList === null || notifList?.length === 0" style="margin-top: 100px">
            <app-loader [loading]="loading" [title] = "'پیامی'"></app-loader>
          </div>
          <div class="notif_list">
            <ul class="list-unstyled">
              <li *ngFor="let item of notifList" [ngClass]="{'active': item.unread}">
                <div class="desc_notif" (click)="goToAdvertisment(item)">
                  <div class="notif_list--t">{{item.title}}</div>
                  <div class="notif_list--date" style="font-family: 'novin_number'; direction: ltr;">
                    {{item.date | jalaliConvertor}}
                  </div>
                </div>
                <button class="btn redBtn btn-auto" (click)="openConfirmModal(item.id)">
                  <img style="margin-left: unset;" src="assets/img/white-trash.svg" alt="">
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-confirm-modal
  [title] ="'حذف پیام'"
  [text] ="selectedIdForDelete === 'all'? 'آیا از حذف همه پیام ها اطمینان دارید؟':'آیا از حذف پیام اطمینان دارید؟'"
  [firstBtn] = "'خیر'"
  [secondBtn] = "'حذف'"
  (doAction1) = "deleteUserNotif()">
</app-confirm-modal>
<app-confirm-modal
  [text] ="selectedIdForDelete === 'all'? 'همه پیام ها با موفقیت حذف شدند.':'پیام با موفقیت حذف شد.'"
  [firstBtn] = "'متوجه شدم'"
  [type] = "'info'"
  [modalId] = "'alert'">
</app-confirm-modal>

<app-snack-bar></app-snack-bar>
